module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo-22-1297267e87394bb0f28cb93cf3b31b4b.svg";